import React from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import { KYCStatus, HoukatsuStatus } from 'apollo/queries/autogenerate/schemas';
import {
  isPlusUser,
  isClassicUser,
} from 'shared/consumer/utils/consumer-types';
import Badge from 'shared/modules/common/components/atoms/Badge';
import Button from 'shared/modules/common/components/atoms/Button';

type Props = {
  onVerifyIdentityButtonPress: () => void;
  kycStatus: KYCStatus | undefined;
  houkatsuStatus: HoukatsuStatus | undefined;
};

type Variant = 'success' | 'danger' | 'warning' | 'info';

const Status = (props: Props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  const getPropsByStatus = () => {
    if (isClassicUser(props.kycStatus)) {
      return {
        title: '本人確認前',
        badge: 'info',
        content: isBigScreen
          ? `本人確認をすると、分割手数料無料*の3・6・12回あと払いが使えるようになります。`
          : `本人確認をすると、分割手数料無料*の\n3・6・12回あと払いが使えるようにな\nります。`,
      };
    } else if (
      props.kycStatus === KYCStatus.PENDING ||
      props.houkatsuStatus === HoukatsuStatus.AWAITING_CIC_RESULTS ||
      props.houkatsuStatus === HoukatsuStatus.AWAITING_PAC_ASSESSMENT
    ) {
      return {
        title: '本人確認手続き中',
        badge: 'warning',
        content: `本人確認手続きが完了すると、分割手数料無料*の3・6・12回あと払いが使えるようになります。`,
      };
    } else if (isPlusUser(props.kycStatus, props.houkatsuStatus)) {
      return {
        title: '本人確認済み',
        badge: 'success',
        content: `分割手数料無料*の3・6・12回あと払いが使えるようになりました。`,
      };
    } else {
      return {
        title: '',
        badge: 'info',
        content: '',
      };
    }
  };

  return (
    <View>
      <View style={styles.titleContainer}>
        <Text style={styles.sectionHeading}>{`ステータス`}</Text>
        <Badge
          title={getPropsByStatus().title}
          variant={getPropsByStatus().badge as Variant}
        />
      </View>
      <Text style={styles.content}>{getPropsByStatus().content}</Text>
      <Text style={styles.disclaimer}>{`*口座振替・銀行振込のみ無料`} </Text>
      {(props.kycStatus === KYCStatus.NEVER_APPLIED ||
        props.kycStatus === KYCStatus.REJECTED) && (
        <Button
          variant="primary"
          title="本人確認する"
          style={styles.button}
          onPress={props.onVerifyIdentityButtonPress}
          id="status-details-verify-identity-button"
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  titleContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: 16,
  },
  sectionHeading: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#2A2E32',
    marginRight: 16,
  },
  content: {
    fontWeight: '300',
    fontSize: 13,
    color: '#1C1C1C',
    marginBottom: 24,
  },
  disclaimer: {
    fontWeight: '300',
    fontSize: 13,
    color: '#586065',
    marginBottom: 24,
  },
  button: {
    maxWidth: 296,
    marginHorizontal: 'auto',
  },
});

export default Status;
